import ILoginQuery from "@/models/login-query";
import axiosService from "@/services/axios-service";
import { LoginInfoKey, ILoginInfo } from "@/models/login-info";
import RESTApiEndPoints from "@/services/rest-api-end-points";

export default class LoginService {
  public async LoginUser(loginQuery: ILoginQuery) {
    return await axiosService.post<LoginInfoKey>(RESTApiEndPoints.loginUrl(), loginQuery);
  }

  public async RefreshToken(refreshToken: string) {
    const formData = new FormData();
    formData.set("refreshToken", refreshToken);
    return await axiosService.post<LoginInfoKey>(
      `${RESTApiEndPoints.loginUrl()}/refresh`,
      formData,
      {
        headers: { "Content-Type": "application/json" }
      }
    );
  }
}
